import { GN_Carousel } from "./gn_carousel";

import { YoutubeIframe } from "./youtube-iframe";

const SELECTORS = {
  carousel: ".video-gallery__slider",
  containers: ".video-gallery__container",
};

const INIT_VIDEO_DELAY_MS = 200;

const initVideoGallery = (context) => {
  const carouselContainers = [
    ...context.querySelectorAll(SELECTORS.containers),
  ];
  const carousels = [];

  if (carouselContainers.length) {
    const options = {
      variableWidth: true,
      watchAria: true,
      watchIframes: true,
      watchArrows: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 768,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
        {
          breakpoint: 991,
          focusOnSelect: false,
          settings: "unslick",
        },
      ],
    };

    carouselContainers.forEach((parent) => {
      const carousel = parent.querySelector(SELECTORS.carousel);
      const instance = new GN_Carousel(carousel, options, parent);
      const iframeInstance = new YoutubeIframe(parent, INIT_VIDEO_DELAY_MS);

      iframeInstance.initPlayer();
      instance.initCarousel();

      // Add resize support
      window.addEventListener("resize", () => {
        const windowWidth = window.innerWidth;

        if (windowWidth <= 1679) {
          instance.initCarousel();
        }
      });

      carousels.push(instance);
    });
  }
};

export { initVideoGallery };
